/**************************************************
 * Nombre:       Dialogo_Deposito
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid} from "@mui/material";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import logo from '../../Recursos/logo_redondo.svg'
import {Check, Delete} from "@mui/icons-material";
import {borrarDoc} from "../../Servicios/BD/borrarDoc";
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import Formulario_Deposito from "../Formularios/Formulario_Deposito";
import {crearLinkPago} from "../../CodNegocio/crearLinkPago";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {irUrl} from "../../Utilidades/irUrl";
import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

const Dialogo_Deposito = ({datos, cerrar, realizado}) => {
    const {props, obtenerEntidad} = useFormulario({valoresDefecto: datos})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        funcionUno: realizado,
        funcionDos: cerrar
    })


    const subirDatos = async () => {

        let entidad = await obtenerEntidad()

        iniciarCarga('Subiendo Datos')
        entidad.fecha = new Date().getTime()
        entidad.id = new Date().getTime() + 'TOS'
        entidad.estado = 'Nuevo'
        entidad.mensaje = 'El deposito esta siendo validado'
        entidad.tipo = 'Deposito'
        let conse = await obtenerConsecutivo({col: 'consecutivos', id: 'depositos'})
        entidad.consecutivo = conse.data

        let res = await crearLinkPago({entidad: entidad})

        if (res.res) {
            irUrl(res.data)
            let dox = await guardarDoc('depositos', entidad)
            if (dox.res) {
                await aumentarConsecutivo({col: 'consecutivos', id: 'depositos', actual: entidad.consecutivo})
                terminar({aviso: 'Tu deposito sera validado en un plazo de 24 horas'})
            } else {
                terminar({aviso: 'Algo salio mal, por favor intetalo nuevamente', variante: 'error'})
            }
        } else {
            terminar({aviso: 'No hemos podido dirigirte a nuestra pasarela de pagos', variante: 'error'})
        }


    }

    const borrar = async () => {
        iniciarCarga('Borrando')
        await borrarDoc('depositos', datos.id)
        terminar({aviso: 'deposito borrado'})
    }
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{p: 1}}
        >

            <Avisos/>

            <Cargador/>

            <Grid container size={{xs: 12, sm: 12, md: 12}}>
                <Formulario_Deposito props={props}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Button
                    startIcon={<Check/>}
                    onClick={() => subirDatos()}
                >Crear Deposito</Button>
            </Grid>

            {datos && datos.id &&
                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Button
                        onClick={() => borrar()}
                        color={'success'} startIcon={<Delete/>} variant={'text'}>
                        Borrar
                    </Button>
                </Grid>
            }


        </Grid>
    )

}
export default Dialogo_Deposito